import { editOrderCheck,updateOrder } from '../../_services/order.service';

export const editOrderCheckEvent = async (uuids, checked) => {
    let res = await editOrderCheck({ uuids, checked });
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const editOrderEvent = async (uuid, inputs) => {
    const body={
        uuid,
        inputs
    }
    let res = await updateOrder(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}